import classNames from 'classnames';
import { GameData } from 'react-easyrocket';
import { useGetGameNameFontSize } from '../hooks/useGetGameNameFontSize';
interface GameGradientProps {
  game: GameData;
}

export const GameGradient = ({ game }: GameGradientProps) => {
  const gameNameFontSize = useGetGameNameFontSize(game.name);

  return (
    <div
      className={classNames(
        'absolute left-0 top-0 z-[3] pb-2 768:pb-3 flex h-full w-full flex-col min-h-[80px] justify-end gap-1 rounded-b-md'
      )}
      style={{
        background: `linear-gradient(180deg, rgba(255, 255, 255, 0) 45.9%, ${game.imagine?.gradient_color} 76.74%)`
      }}>
      <div className="flex flex-col items-center px-1.5 justify-center text-center font-bold uppercase text-gc_name_game">
        <p
          className="line-clamp-2 leading-[100%]"
          style={{
            fontSize: `${gameNameFontSize}cqw`
          }}>
          {game.name}
        </p>
      </div>
      <p className="line-clamp-1 text-center text-xs 768:text-sm leading-[16px] px-2 text-gc_name_game">
        {game.providerName}
      </p>
    </div>
  );
};
